export const getWordAndPunctuation = (
  word: string
): { wordToDisplay: string; punctuationMark: string } => {
  const punctuationRegex = new RegExp(/[,.;!?]/);
  const wordToDisplay = word.split(punctuationRegex)[0];
  const punctuationMark = word.split(wordToDisplay)?.[1] || '';
  return { wordToDisplay, punctuationMark };
};
